import type { MessageSize } from './types/StatusMessageTypes'

const FONT_SIZES: Record<MessageSize, string> = {
    large: '1.125rem',
    normal: '1rem',
    small: '.875rem',
}

const StatusText = ({ children, size = 'small' }: { children: string; size?: MessageSize }) => (
    <span className="status-message__text" style={{ fontSize: FONT_SIZES[size] }}>
        {children}
    </span>
)

export default StatusText
